import { Tooltip } from "@mui/material";
import { ReactElement } from "react";
import type { SourceBundle } from "../../graphql/types";
import { exists } from "../../lib/Util";
import { HumanDate } from "../Date";
import { ProgressBarWaiting } from "../ui/ProgressBars";

const getProbeToolTipText = ({ recent_successful_probe, next_probe }: Partial<SourceBundle>) => {
  let recentSuccessfulProbe;
  if (!recent_successful_probe) {
    recentSuccessfulProbe = <span>Source has not been probed yet.</span>;
  } else {
    recentSuccessfulProbe = (
      <span>
        Last probed at <HumanDate date={recent_successful_probe} />.
      </span>
    );
  }

  let nextProbe;
  if (next_probe) {
    nextProbe = (
      <span>
        Next probe will be at <HumanDate date={next_probe} />.
      </span>
    );
  } else {
    nextProbe = <span>Next probe will be scheduled shortly.</span>;
  }
  return (
    <div>
      {recentSuccessfulProbe} {nextProbe}
    </div>
  );
};

const ProbeStatus = ({ sourceBundle }: { sourceBundle?: Partial<SourceBundle> | null }) => {
  let statusMessage = "";
  let toolTipText: ReactElement | string | null = null;
  if (sourceBundle && exists(sourceBundle.report_handle)) {
    statusMessage = "Checking for new files";
    toolTipText = getProbeToolTipText(sourceBundle);
  } else {
    statusMessage = "Subscribing";
    toolTipText = "Report is being created at provider.  Check back later for an estimated download start time.";
  }

  return (
    <Tooltip id="tooltip" title={toolTipText} placement="left" arrow>
      <div data-cy="waiting-progress-bar">
        <ProgressBarWaiting status={"queued"} badgeText={statusMessage} testLabel="processing" />
      </div>
    </Tooltip>
  );
};

export { ProbeStatus };
